import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { DocumentType } from '@synergy/models';
import { getUrlSegment } from '@synergy/utils';

import { DocumentChainStep } from '../models/document-chain-step';
import { TransitionActivity } from '../models/transition-activity';
import { TransitionActivityMeta } from './models/transition-activity-meta';

export class TransitionActivitiesApi {
    constructor(protected baseUrl: string) {}

    /**
     * Every document of the procurement chain this one belongs to, in the order
     * the chain was built (#2160) — not only its direct neighbours.
     */
    public getDocumentChain(documentType: DocumentType, documentId: number): Promise<ApiResult<DocumentChainStep[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/document-chain/${getUrlSegment(documentType)}/${documentId}`),
            // A plain array, not a paginated response: a chain is answered
            // whole, and the longest one in the system holds 297 documents.
            response => response.data.map(DocumentChainStep.fromPlainObject)
        );
    }

    public getTransitionsActivities(
        documentType: DocumentType,
        documentId: number
    ): Promise<ApiResult<PaginatedResponse<TransitionActivity, TransitionActivityMeta>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/transitions/${getUrlSegment(documentType)}/${documentId}`),
            response => {
                response.data.items = response.data.items.map(TransitionActivity.fromPlainObject);
                return response.data;
            }
        );
    }
}
